
export function unique(array) {
	return array.filter((x, i, a) => a.indexOf(x) === i)
}

export function chunk(array, length) {
  let chunks = [],
      i = 0,
      n = array.length;
  while (i < n) chunks.push(array.slice(i, i += length))
  return chunks
}
